import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { BookingButton } from './BookingButton';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Acasă',
    path: '/'
  }, {
    name: 'Consultanță',
    path: '/magazin'
  }, {
    name: 'Despre Mine',
    path: '/despremine'
  }, {
    name: 'Testimoniale',
    path: '/testimoniale'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={`fixed top-0 left-0 w-full z-50 bg-[#09111F] transition-[padding,box-shadow] duration-200 ease-out ${isScrolled ? 'py-3 shadow-lg' : 'py-4'}`} data-id="element-110" data-mp="2wkupj2u89zai">
      <div className="max-w-[1200px] mx-auto px-5 md:px-12 flex items-center justify-between" data-id="element-111" data-mp="2rkgfxgczahad">
        <Link to="/" aria-label="ProVi System — Valer Dura, Business Consultant" className="z-50 bg-white rounded-lg px-3 py-1.5 flex items-center shrink-0" data-id="element-112" data-mp="2mmx1ogga64if">
          <img src="https://cdn.magicpatterns.com/uploads/qrtsVcBg2sA9RUyyH64JJx/LOGO_VALER_PROVISYSTEM.png" alt="ProVi System — Valer Dura, Business Consultant" className={`w-auto transition-[height] duration-200 ease-out ${isScrolled ? 'h-8' : 'h-9'}`} data-id="element-113" data-mp="3fblttpzcyzi1" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-6" data-id="element-114" data-mp="30n7u3nx8nr5p">
          <div className="flex items-center gap-5" data-id="element-115" data-mp="30klkzjup93ld">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-['Inter'] text-[14px] transition-colors ${location.pathname === link.path ? 'text-white font-medium' : 'text-[rgba(255,255,255,0.7)] hover:text-white'}`} data-id="element-116" data-mp="1xqu8q7lpopi">
                {link.name}
              </Link>)}
          </div>
          <BookingButton text="Diagnostic Gratuit" className="px-5 py-2.5 text-[13px]" data-id="element-117" data-mp="1wbcw1c7ml648" />
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white z-50 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-118" data-mp="1hlxe8lq2ob0o">
          {isMobileMenuOpen ? <X size={24} data-id="element-119" data-mp="18mtvxjyqbzn8" /> : <Menu size={24} data-id="element-120" data-mp="18madm256398o" />}
        </button>

        {/* Mobile Nav */}
        <div className={`fixed inset-0 bg-[#09111F] z-40 flex flex-col pt-24 px-6 transition-transform duration-300 lg:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-121" data-mp="1cp6qrdbxud58">
          <div className="flex flex-col gap-4 overflow-y-auto pb-24" data-id="element-122" data-mp="13nqpbv33pld5">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-['Montserrat'] text-lg py-2 border-b border-[rgba(255,255,255,0.05)] ${location.pathname === link.path ? 'text-white font-bold' : 'text-[rgba(255,255,255,0.7)]'}`} data-id="element-123" data-mp="2t2x4zcwruhsl">
                {link.name}
              </Link>)}
            <div className="mt-6" data-id="element-124" data-mp="mcbpiwjzrdb0">
              <BookingButton text="Diagnostic Gratuit" className="w-full" data-id="element-125" data-mp="hg3dvt50628l" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}